<template>
  <section
    class="full-loading"
    :class="{ absolute, [theme]: !!theme }"
    :style="[background ? `background-color: ${background}` : '']"
    v-show="loading"
  >
    <!-- 品牌化加载指示(替换 Antd 默认 Spin,老板 2026-08-26 要求):logo 呼吸 + 青色光环 -->
    <div class="dr-loading" :class="size">
      <div class="dr-loading-orbit">
        <span class="ring"></span>
        <span class="ring delay"></span>
        <img class="dr-loading-logo" src="../../../assets/images/logo.png" alt="DataRiver" />
      </div>
      <div class="dr-loading-tip">{{ tip || '加载中…' }}</div>
    </div>
  </section>
</template>
<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import { SizeEnum } from '/@/enums/sizeEnum';

  export default defineComponent({
    name: 'Loading',
    props: {
      tip: {
        type: String as PropType<string>,
        default: '',
      },
      size: {
        type: String as PropType<SizeEnum>,
        default: SizeEnum.LARGE,
        validator: (v: SizeEnum): boolean => {
          return [SizeEnum.DEFAULT, SizeEnum.SMALL, SizeEnum.LARGE].includes(v);
        },
      },
      absolute: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      background: {
        type: String,
      },
      theme: {
        type: String as PropType<'dark' | 'light'>,
      },
    },
  });
</script>
<style lang="less" scoped>
  @dr-primary: #2c7a99;
  @dr-cyan: #5fe9ff;

  .full-loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 200;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background-color: rgb(240 242 245 / 55%);
    backdrop-filter: blur(2px);

    &.absolute {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 300;
    }
  }

  html[data-theme='dark'] {
    .full-loading:not(.light) {
      background-color: @modal-mask-bg;
    }
  }

  .full-loading.dark {
    background-color: @modal-mask-bg;
  }

  .dr-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 14px;

    .dr-loading-orbit {
      position: relative;
      display: grid;
      place-items: center;

      .ring {
        position: absolute;
        inset: 0;
        border-radius: 50%;
        border: 2px solid transparent;
        border-top-color: @dr-primary;
        border-right-color: @dr-cyan;
        animation: dr-spin 0.9s linear infinite;
      }

      .ring.delay {
        inset: 7px;
        animation-duration: 1.4s;
        animation-direction: reverse;
        border-top-color: @dr-cyan;
        border-right-color: transparent;
        opacity: 0.55;
      }

      .dr-loading-logo {
        animation: dr-breathe 1.8s ease-in-out infinite;
      }
    }

    .dr-loading-tip {
      font-size: 13px;
      letter-spacing: 2px;
      color: #4a6a80;
    }
  }

  /* 尺寸档位:与原 Spin 的 small/default/large 语义对齐 */
  .dr-loading.small .dr-loading-orbit {
    width: 36px;
    height: 36px;
    .dr-loading-logo {
      width: 18px;
    }
  }
  .dr-loading.default .dr-loading-orbit {
    width: 52px;
    height: 52px;
    .dr-loading-logo {
      width: 26px;
    }
  }
  .dr-loading.large .dr-loading-orbit {
    width: 72px;
    height: 72px;
    .dr-loading-logo {
      width: 36px;
    }
  }

  @keyframes dr-spin {
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes dr-breathe {
    0%,
    100% {
      transform: scale(1);
      opacity: 0.85;
    }
    50% {
      transform: scale(1.12);
      opacity: 1;
    }
  }
</style>
